import { Download, ShoppingBag, ChefHat } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      icon: Download,
      title: "Baixe o e-book",
      description: "Receba o PDF com acesso imediato após a compra. Disponível em qualquer dispositivo.",
    },
    {
      number: "2",
      icon: ShoppingBag,
      title: "Faça a compra única",
      description: "Use a lista consolidada para comprar tudo de uma vez ou adapte ao que já tem em casa.",
    },
    {
      number: "3",
      icon: ChefHat,
      title: "Cozinhe em 30 minutos",
      description: "Escolha a receita do dia e prepare um almoço delicioso rapidamente, sem complicação.",
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            Como funciona
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Três passos simples para transformar seus almoços
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3 max-w-5xl mx-auto">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-primary to-secondary"></div>
                )}
                <Card 
                  className="border-2 text-center relative z-10 bg-background animate-slide-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <CardContent className="pt-8 pb-6">
                    <div className="mb-6 mx-auto w-20 h-20 rounded-full bg-gradient-warm flex items-center justify-center shadow-soft">
                      <Icon className="h-10 w-10 text-white" />
                    </div>
                    <h3 className="mb-3 text-xl font-bold">{step.title}</h3>
                    <p className="text-muted-foreground">{step.description}</p>
                  </CardContent>
                </Card>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
